<frontend-pull-refresh></frontend-pull-refresh>

<section class="pb-3 px-3">
  <div class="mb-4">
    <tablesready-tabs
      [tabs]="tabs"
      [activeTab]="activeTab"
      (changeTab)="onChangeTab($event)"
    ></tablesready-tabs>
  </div>

  <div *ngIf="activeTab === tabValues.users">
    <tablesready-location-users-list></tablesready-location-users-list>
  </div>

  <div *ngIf="activeTab === tabValues.invites">
    <tablesready-location-invites-list [timezone]="timezone"></tablesready-location-invites-list>
  </div>

</section>
